import { CommonWork } from './CommonWork'
import { EmployeePosition } from '@/models/EmployeePosition'
import { List } from './List'

export class JournalEditorialBoardParent extends List {
  constructor(obj) {
    super(JournalEditorialBoard, obj)
  }
}

export class JournalEditorialBoard {
  constructor(obj) {
    this.id = obj?.id || null
    this.commonWork = new CommonWork(obj?.commonWork || null)
    this.linkToEditorialBoardPage = obj?.linkToEditorialBoardPage || null
    this.listedByWAK = obj?.listedByWAK || false
    this.actual = obj?.actual || null
    this.bibliography = obj?.bibliography || null
    this.catalog = obj?.catalog || null
    this.editorialBoardRole = obj?.editorialBoardRole || null
    this.employeePosition = new EmployeePosition(obj?.employeePosition || null)
    this.magazine = obj?.magazine || null
    this.remark = obj?.remark || null
  }

  getForAPI() {
    return {
      id: this.id,
      actual: this.actual,
      commonWork: this.commonWork.getForAPI(),
      linkToEditorialBoardPage: this.linkToEditorialBoardPage,
      listedByWAK: this.listedByWAK,
      bibliography: this.bibliography,
      catalog: this.catalog,
      editorialBoardRole: this.editorialBoardRole,
      employeePosition: this.employeePosition,
      magazine: this.magazine,
      remark: this.remark
    }
  }
}
